var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { Flex } from "../../Flex";
import { SvgIcon } from '../../../icons';
import { dateFormat, parseDate, normalizeDate } from "../../../helpers/date";
import padStart from "lodash/padStart";
import getMonth from "date-fns/getMonth";
import getYear from "date-fns/getYear";
import getDate from "date-fns/getDate";
import { Select } from "../Select/Select";
import i18next from "i18next";
function sequence(start, end) {
    var array = [];
    for (var i = start; i <= end; i += 1) {
        array.push(i);
    }
    return array;
}
function datesInMonth(year, month) {
    switch (month) {
        case 2:
            // February
            var leapYear = ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
            return leapYear ? 29 : 28;
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
            return 31;
        default:
            return 30;
    }
}
var deriveState = function (date) {
    return {
        date: date ? getDate(date) : "",
        month: date ? getMonth(date) + 1 : "",
        year: date ? getYear(date) : "",
    };
};
var DateField = /** @class */ (function (_super) {
    __extends(DateField, _super);
    function DateField(props) {
        var _this = _super.call(this, props) || this;
        _this.currentYear = (new Date()).getFullYear();
        _this.years = sequence(1900, _this.currentYear).reverse();
        _this.months = sequence(1, 12).map(function (month) { return ({ label: dateFormat(new Date(0, month, 0), "MMMM"), value: month }); });
        _this.state = {
            dates: [],
            date: "",
            month: "",
            year: ""
        };
        _this.labels = {
            year: i18next.t("date.year"),
            month: i18next.t("date.month"),
            date: i18next.t("date.date"),
        };
        _this.onChangeDay = function (value) {
            _this.setFieldState("date", value);
        };
        _this.onChangeMonth = function (value) {
            var month = value;
            _this.setDates(__assign(__assign({}, _this.state), { month: month }));
            _this.setFieldState("month", month);
        };
        _this.onChangeYear = function (value) {
            var year = value;
            _this.setDates(__assign(__assign({}, _this.state), { year: year }));
            _this.setFieldState("year", year);
        };
        _this.onChange = function () {
            var _a, _b;
            var _c = _this.state, _d = _c.date, date = _d === void 0 ? "" : _d, _e = _c.month, month = _e === void 0 ? "" : _e, _f = _c.year, year = _f === void 0 ? "" : _f;
            var value;
            if (date && month && year) {
                value = parseDate(padStart(year + "", 4, "0") + "-" + month + "-" + date, "yyyy-MM-dd");
            }
            else if (!_this.props.value) {
                return;
            }
            value = (value === null || value === void 0 ? void 0 : value.getDate()) ? value : undefined;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        };
        var value = null;
        try {
            value = normalizeDate(_this.props.value);
            value = (value === null || value === void 0 ? void 0 : value.getDate()) ? value : null;
        }
        catch (_a) { }
        _this.state = __assign(__assign({}, deriveState(value)), { dates: [] });
        return _this;
    }
    DateField.prototype.componentDidMount = function () {
        this.setDates(this.state);
    };
    DateField.prototype.setDates = function (props) {
        var numDates = props.month ? datesInMonth(+props.year, +props.month) : 31;
        var dates = sequence(1, numDates);
        this.setState({ dates: dates });
        if (props.date > numDates) {
            this.onChangeDay(null);
        }
    };
    DateField.prototype.setFieldState = function (prop, value) {
        var _a;
        var _this = this;
        this.setState((_a = {}, _a[prop] = value, _a), function () {
            _this.onChange();
        });
    };
    DateField.prototype.render = function () {
        return (React.createElement(DateFieldWrap, null,
            React.createElement(SelectField, { isInvalid: !this.state.date, options: this.state.dates, placeholder: this.labels.date, name: "date", onChange: this.onChangeDay, value: this.state.date }),
            React.createElement(SelectField, { isInvalid: !this.state.month, options: this.months, placeholder: this.labels.month, name: "month", onChange: this.onChangeMonth, value: this.state.month }),
            React.createElement(SelectField, { isInvalid: !this.state.year, options: this.years, placeholder: this.labels.year, name: "year", onChange: this.onChangeYear, value: this.state.year })));
    };
    return DateField;
}(React.Component));
export { DateField };
var SelectField = styled(Select).attrs(function (props) { return ({ isInvalid: props.isInvalid }); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isInvalid = _a.isInvalid;
    return isInvalid ? "--ws-input-color: var(--ws-input-placeholder-color, #aaa);" : "";
});
var DateFieldWrap = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 5px;\n    gap: 1em;\n    \n    ", " {\n        margin-bottom: 0;\n        flex: 1;\n    }\n\n    + ", " {\n        top: auto;\n        height: auto;\n        bottom: 100%;\n        right: 0;\n        transform: none;\n    }\n"], ["\n    margin-top: 5px;\n    gap: 1em;\n    \n    ", " {\n        margin-bottom: 0;\n        flex: 1;\n    }\n\n    + ", " {\n        top: auto;\n        height: auto;\n        bottom: 100%;\n        right: 0;\n        transform: none;\n    }\n"])), Select, SvgIcon);
var templateObject_1, templateObject_2;
